// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1A0MA","title":"ClientReferral_title__1olq-","itemText":"ClientReferral_itemText__x-JdL"};